import { FC } from "react";

import { Translate } from "@/app/application/Translate";

import CloseIcon from "@/assets/svg/interactions/icon-close.svg?react";
import SaveIcon from "@/assets/svg/interactions/icon-save.svg?react";

interface IModal {
	show: boolean;
	CloseModal: () => void;
}
export const Modal: FC<IModal> = (props) => {
	const showModal = props.show ? "modal--open" : "";

	return (
		<div
			onClick={(e) => {
				e.stopPropagation();
				props.CloseModal();
			}}
			className={`modal ${showModal}`}
		>
			<div className="modal-inner">
				<div
					className="modal-container"
					role="dialog"
					aria-modal="true"
					aria-labelledby="modal-dialog-title"
					onClick={(event) => event.stopPropagation()}
				>
					{props.children}
				</div>
			</div>
		</div>
	);
};

interface IModalHeader {
	title?: string | undefined;
	CloseModal: (event: MouseEvent) => void;
}

export const ModalHeader: FC<IModalHeader> = (props) => {
	return (
		<header className="modal-header" id="modal-dialog-title">
			{props.children}
			<button
				className="button-icon"
				type="button"
				id="triggerModalClose"
				aria-label="Close"
				onClick={props.CloseModal}
			>
				<CloseIcon className="svg-icon svg-icon--close" />
			</button>
		</header>
	);
};

interface IModalContent {
	errorMessages?: string | Array<string> | undefined;
}

export const ModalContent: FC<IModalContent> = (props) => {
	if (Array.isArray(props.errorMessages) && props.errorMessages.length > 0) {
		return (
			<section className="modal-content">
				{props.children}
				<div className="row-one-column border-2 p-4 border-red-600">
					<div className="error text-red-600">
						<ul>
							{props.errorMessages.map((error) => (
								<li>{error}</li>
							))}
						</ul>
					</div>
				</div>
			</section>
		);
	}

	if (typeof props.errorMessages === "string") {
		return (
			<section className="modal-content">
				{props.children}
				<div className="row-one-column border-2 p-4 border-red-600">
					<div className="error text-red-600">{props.errorMessages}</div>
				</div>
			</section>
		);
	}

	return <section className="modal-content">{props.children}</section>;
};

interface IModalFooter {
	Save: () => void;
}
export const ModalFooter: FC<IModalFooter> = (props) => {
	return (
		<footer className="modal-footer">
			<button
				onClick={() => props.Save()}
				className="button-icon button-text button--blue"
				type="button"
			>
				<SaveIcon className="svg-icon svg-icon--save" />
				<Translate String="Procedure.CommentOverlay.Save">Save</Translate>
			</button>
		</footer>
	);
};
